import { u, styled } from '../../../../shared/theming-sc'

const Td = styled.td`
    position: relative;
    padding: 10px 40px 10px 0px;
    font-size: ${u.getFontSize('md')};
    vertical-align: middle;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.6;
    letter-spacing: normal;
    color: ${u.getColor('greyDark')};
    display: table-cell;
    height: auto !important;
    

    &.actions-cell {
        text-align: right;
    }


    &:first-child{ 
      padding-left: 30px !important;

      a {
        width: auto !important;
      }
    }

    &.sub-row {
        background: #f9f9f9;

        &.frozen-cell {
            &:first-child{
                &::before{
                    background: #f9f9f9 !important;
                    height: auto;
                }
            }
        }
    }

    &.frozen-cell {
    
      &:first-child{
         padding-left: 20px;
         z-index: 20;
         overflow: hidden;

        &::before {
            height: 200%;
            position: absolute;
            left: 0;
            right: ${u.getSpacing('small')}px;
            background: white;
            top: 0;
            content: '';
            display: block;
            z-index: 19px;
        }

        &::after{
            background: linear-gradient(to right, rgba(0, 0, 0, .1) 0%,rgba(0,0,0,0) 66.666%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
            width: 15px;
            height: 200%;
            bottom: -1px;
            position: absolute;
            right: 10px;
            top: 0;
            display: block;
            z-index: 25;
            content: "";  
        }
      }
    }
`

const DataItem = styled.span`

   display: ${props => (props.showToolTip ? '' : 'inline-block')};
   width: 100%;
   position: ${props => (props.count === 0 ? 'relative' : '')};
   height: 24px;
   z-index: 1;

    white-space:nowrap;
    text-overflow:ellipsis;
    overflow: hidden;

   &.truncate {
    /* this is where the truncation will be controlled: TODO */
   }

   &.style1 {
        :nth-child(even) {
            font-size: ${u.getFontSize('md')};
            font-family: ${u.getFontFamily('knowledge', 'light')};
            letter-spacing: normal;
            color: ${u.getColor('greyLight')};
        }
    }
    &.multilinecolumn_style1 {
        :nth-child(odd) {
            font-size: ${u.getFontSize('tn')};
            font-family: ${u.getFontFamily('knowledge', 'black')};
            letter-spacing: 2px;
            color: ${u.getColor('greyDark')};
        }
        :nth-child(even) {
            vertical-align: bottom;
            font-size: ${u.getFontSize('tn')};
            font-family: ${u.getFontFamily('knowledge', 'black')};
            letter-spacing: 2px;
            color: ${u.getColor('greyLight')};
        }
    }
  }
`

const DataItemLink = styled.a`
   white-space:nowrap;
   text-overflow:ellipsis;
   overflow: hidden;
   display: inline-block;
   width: 100%;
   position: relative;
   height: 24px;
   z-index: 1;
   color: ${u.getColor('greyDark')};
   font-weight: 600;
   text-decoration: underline;

   &:hover {
    color: ${u.getColor('greyDarkest')};
    text-decoration: underline;
   }
`

const CheckBox = styled.input`
    position: relative;
    z-index: 10;
    margin-right: ${u.getSpacing('smaller')}px;
    outline: none;
    border: 1px solid ${u.getColor('greyLight')};
    background: white;
    top: -1px;
    margin-left: ${u.getSpacing('smaller')}px;
    float: left;
`

const OpenSubRow = styled.span`
    position: relative;
    display: inline-block;
    width: 20px;
    cursor: pointer;
    top: ${u.getSpacing('tiny')}px;
    margin-right: ${u.getSpacing('smaller')}px;
    float: left;
`

const DataFlag = styled.span`
    display: block;
    position: absolute;
    width: 3px;
    left: 0;
    top: 0px;
    bottom: 0px;
`

const SubCount = styled.span`
    display: block;
    border-radius: ${u.getSpacing('small')}px;
    height: ${u.getSpacing('small')}px;
    width: ${u.getSpacing('small')}px;
    background: ${u.getColor('greyDark')};
    color: white;
    text-align: center;
    font-size: ${u.getFontSize('sm')};
    box-sizing:border-box;
    padding-top: 0px;
    cursor: default;
    font-weight: 600;
`

const CheckboxWrapperSpan = styled.span.attrs({
  style: ({ padding, disabled }) => ({ 
    padding,
    cursor: disabled ? 'default' : 'pointer'
  })
})`
    top: ${u.getSpacing('tiny')}px;
    display: inline-block;
    margin-left: ${u.getSpacing('smaller')}px;
    margin-right: 13px;
    width: 14px;
    height: 14px;
    float: left;
`

const SubStyle = styled.span`
    position: relative;
    display: inline-block;
`;

export {
  Td,
  DataItem,
  DataItemLink,
  CheckBox,
  OpenSubRow,
  DataFlag,
  SubCount,
  SubStyle,
  CheckboxWrapperSpan
}
